export type ClientPortalRuntimeConfig = {
  apiUrl: string;
  auth0: {
    domain: string;
    clientId: string;
    audience: string;
  };
  getQuoteUrl: string;
  gtmId: string;
  environment: string;
  useDevAuth: boolean | string;
  insurer: string;
};

declare global {
  interface Window {
    clientPortal?: ClientPortalRuntimeConfig;
  }
}

export var clientPortalConfig: ClientPortalRuntimeConfig = {
  apiUrl: 'VUE_APP_API_URL',
  auth0: {
    domain: 'VUE_APP_AUTH0_DOMAIN',
    clientId: 'VUE_APP_AUTH0_CLIENT_ID',
    audience: 'VUE_APP_AUTH0_AUDIENCE',
  },
  getQuoteUrl: 'VUE_APP_GET_QUOTE_URL',
  gtmId: 'VUE_APP_GTM_ID',
  environment: 'VUE_APP_ENVIRONMENT',
  useDevAuth: 'VUE_APP_USE_DEV_AUTH',
  insurer: 'VUE_APP_INSURER',
}

export function initClientPortalConfig() {
  var useDevAuth = String(clientPortalConfig.useDevAuth) === 'true'
  window.clientPortal = {
    ...clientPortalConfig,
    useDevAuth,
  }
  clientPortalConfig.useDevAuth = useDevAuth
  return window.clientPortal
}

export function getApiUrl() {
  return window.clientPortal?.apiUrl ?? clientPortalConfig.apiUrl
}

export function useDevAuthEnabled() {
  return window.clientPortal?.useDevAuth === true
}

export function isAuth0Configured() {
  var domain = clientPortalConfig.auth0.domain
  var clientId = clientPortalConfig.auth0.clientId
  if (!domain || !clientId) {
    return false
  }
  if (domain.startsWith('VUE_APP_') || clientId.startsWith('VUE_APP_')) {
    return false
  }
  return true
}
